// 登录态打开时单次校验（账号级登录态同步）
// 同步机制不依赖轮询：任一端登出 → 后端账号级清除 token → 本端调用登录态接口时
// 中间件返回 HTTP 401 + token 类 sub_code（40101-40107）→ siteClient 拦截器自动登出。
// 本文件仅在页面加载时恢复本地登录态并校验一次（打开页面即可感知其他端已登出），不做定时/事件轮询。
// SSR-safe：onMounted 仅 client 执行。

import { onMounted, onBeforeUnmount } from 'vue'
import { useAuthStore, AUTH_STORAGE_KEY } from '@/stores/auth'
import { apiUserState } from '@/api/auth'

export function useAuthSync() {
  const auth = useAuthStore()

  function handleStorage(e: StorageEvent) {
    // 其他标签登出/登录导致 yfb.auth 变化（或整站数据被清空）→ 本标签重新水合，
    // 保持多标签登录态一致，避免"A 标签已登出、B 标签仍显示已登录"。
    if (e.key !== null && e.key !== AUTH_STORAGE_KEY) return
    void auth.hydrate()
  }

  onMounted(async () => {
    if (typeof window === 'undefined') return
    // root 层没有其它 hydrate 入口，先恢复本地登录态再校验一次
    await auth.hydrate()
    if (auth.isLoggedIn) {
      try {
        // 2026-08-08：合并状态快照（顺带校验 token 有效性，401 → 拦截器清登录态）
        const state = await apiUserState()
        auth.setUserInfo(state.user)
      } catch {
        // 401 → siteClient 拦截器已 auth.clear()（含跳登录页）；其他异常忽略
      }
    }
    window.addEventListener('storage', handleStorage)
  })

  onBeforeUnmount(() => {
    if (typeof window === 'undefined') return
    window.removeEventListener('storage', handleStorage)
  })
}
